<template>
  <div class="container">
    <template>
      <div class="pricing-switcher">
        <div class="fieldset">
          <input
            type="radio"
            name="group-a"
            :value="true"
            id="pdf"
            v-model="capturePdf"
          />
          <label for="pdf">{{ $tc('upload', 2) }}</label>
          <input
            type="radio"
            name="group-a"
            :value="false"
            id="url"
            v-model="capturePdf"
          />
          <label style="font-size: 15px;" for="url">{{
            $tc('addURL', 2)
          }}</label>
          <span class="switch"></span>
        </div>
      </div>
    </template>

    <div v-if="capturePdf" class="file">
      <!-- <div class="tipWrapper">
        <div class="help-tip">
          <p>
            {{ $t('proposedFormate') }}: <strong>pdf </strong><br />
            {{ $t('maxSize') }}: <strong>5Mb</strong>
          </p>
        </div>
      </div> -->
      <form @submit.prevent="onSubmit" enctype="multipart/form-data">
        <div class="upload-btn-wrapper">
          <div v-if="pdfType !== 'UPLOAD' || isPDFUploaded || !client.tc_url || client.tc_url === ''">
            <button class="btnUpload">{{ $t('uploadPdf') }}</button>
            <input type="file" ref="file" id="input-tag" @change="onSelect" />
          </div>

          <a
            v-if="pdfType === 'UPLOAD' && (client.tc_url || blobURL)"
            @click.prevent="downloadPdf"
            href="#"
          >
            <i class="fas fa-file-pdf"></i>
          </a>
        </div>
        <br />
        <br />
        <div class="fields">
          <button class="edit-btn" :disabled="!isPDFUploaded">
            <font-awesome-icon class="icon" icon="upload" />
            <span> {{ $t('save') }} </span>
          </button>
        </div>
      </form>

      <button class="delete-btn" v-if="client.tc_url" @click="deletePdf">
        <font-awesome-icon class="icon" icon="trash" />
        <span> {{ $t('delete') }} </span>
      </button>

      <div v-if="errMessage" class="errMessage">
        <h5>{{ errMessage }}</h5>
      </div>
      <div class="successMessage">
        <h5>{{ successMessage }}</h5>
      </div>
    </div>
    <div v-else class="formYT">
      <span
        ><img
          class="ytIcon"
          src="../../assets/static/icons/url-link-svgrepo-com.svg"
      /></span>
      <input
        type="text"
        class="urlInput"
        v-model="termsUrl"
        :placeholder="$t('copyURL')"
        @blur="$v.termsUrl.$touch()"
      />
      <template v-if="$v.termsUrl.$invalid">
        <div v-if="!$v.termsUrl.url" class="errorMessage">
          {{ $t('validUrlReq') }}
        </div>
      </template>

      <br />
      <br />
      <button class="edit-btn" @click="upsertTCUrl()">
        {{ $t('save') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { url } from 'vuelidate/lib/validators'

export default {
  name: 'videoUpload',
  data() {
    return {
      file: '',
      errMessage: '',
      successMessage: '',
      capturePdf: true,
      termsUrl: '',
      isPDFUploaded: false,
      baseUrl: process.env.VUE_APP_API_URL,
      blobURL: '',
      pdfType: null
    }
  },
  validations: {
    termsUrl: { url }
  },
  async mounted() {
    const clientDetails = await this.$store.dispatch('client/fetchClient', JSON.parse(localStorage.getItem('user')).id)
    this.client = clientDetails[0]
    if (this.client.tc_url) {
      if (this.client.tc_url.includes(`/uploadsDoc/${this.client.id}/`)) {
        this.pdfType = 'UPLOAD'
      } else {
        this.pdfType = 'URL'
        this.termsUrl = this.client.tc_url
      }
    }
  },
  methods: {
    onSelect() {
      this.pdfType = 'UPLOAD'
      const allowedTypes = ['application/pdf']
      const file = this.$refs.file.files[0]
      if (file) {
        this.file = file
        if (!allowedTypes.includes(file.type)) {
          this.errMessage = 'Only .pdf formats are acceptable'
        } else if (file.size > 3500000) {
          this.errMessage = 'Too large, max size allowed is 3.5Mb'
        } else {
          this.errMessage = ''
          this.isPDFUploaded = true
          this.blobURL = URL.createObjectURL(file)
        }
        setTimeout(() => (this.errMessage = ''), 3000)
      } else {
        this.isPDFUploaded = false
      }
    },
    async onSubmit() {
      const formData = new FormData()
      formData.append('file', this.file)
      const url = `${process.env.VUE_APP_API_URL}/uploadsDoc`
      try {
        const response = await axios.post(url, formData)
        this.isPDFUploaded = false
        this.client.tc_url = response.data.cloudUrl
        this.termsUrl = ''
        this.pdfType = 'UPLOAD'
        this.successMessage = this.$t('uploadSuccess')
        setTimeout(() => (this.successMessage = ''), 3000)
      } catch (err) {
        console.log(`err while uploading pdf = `, err)
        this.successMessage = err.response.data.error
        setTimeout(() => (this.successMessage = ''), 3000)
      }
    },
    async deletePdf() {
      const url = `${process.env.VUE_APP_API_URL}/client/tc?pdf_path=${this.client.tc_url}`
      try {
        await axios.delete(url)
        this.isPDFUploaded = false
        this.client.tc_url = ''
        this.blobURL = ''
        this.successMessage = this.$t('deletedTCpdf')
        setTimeout(() => (this.successMessage = ''), 3000)
      } catch (err) {
        console.log(`err while deleting pdf = `, err)
        this.successMessage = err.response.data.error
        setTimeout(() => (this.successMessage = ''), 3000)
      }
    },
    async upsertTCUrl() {
      if (this.pdfType === 'UPLOAD' && this.client.tc_url) {
        await this.deletePdf()
      }
      const client = {
        id: this.client.id,
        tc_url: this.termsUrl.trim()
      }
      await this.$store.dispatch('client/editClient', client)
      this.pdfType = 'URL'
      alert(this.$t('URLSuccess'))
      this.client.tc_url = this.termsUrl
    },
    async downloadPdf() {
      const filename = 'General Terms.pdf'
      const url = this.client.url || this.blobURL
      try {
        const response = await fetch(url)
        const blob = await response.blob()

        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        console.error('Error downloading PDF:', error)
      }
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.errMessage {
  color: var(--primaryDark);
  padding: 10px 2px;
}

.ytIcon {
  width: 35px;
  margin-right: 10px;
}

.successMessage {
  color: var(--bg);
  padding: 10px 2px;
}
.container {
  display: inline-block;
  width: 50%;
  padding: 0 30px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

.urlInput {
  width: 80%;
  height: 40px;
  border: solid 2px var(--bg-light);
  border-radius: 5px;
  margin: 20px 5px 5px 5px;
}

.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  font-style: italic;
}
$color-1: var(--primaryDark);
$color-2: var(--bright);
$color-3: var(--bg-light);
$color-4: var(--bg-superLight);

.pricing-switcher {
  $bg-padding: 5px;
  $button-width: 110px;
  $button-height: 40px;
  $animation-time: 0.3s;
  text-align: center;
  margin-bottom: 2%;

  .fieldset {
    display: inline-block;
    position: relative;
    margin-top: 1.3em;
    padding: $bg-padding;
    border-radius: 50em;
    box-shadow: 0px 1px 5px var(--bg-superLight);
    background-color: var(--grey);
  }

  input[type='radio'] {
    position: absolute;
    opacity: 0;
  }

  label {
    position: relative;
    margin: 0;
    z-index: 1;
    display: inline-block;
    float: left;
    width: $button-width;
    height: $button-height;
    line-height: $button-height;
    cursor: pointer;
    color: $color-3;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: bold;
    transition-delay: 0.1s;
    transition: color $animation-time ease;
  }

  input[type='radio']:checked + label {
    color: $color-2;
    text-decoration: none;
  }

  .switch {
    /* floating background */
    position: absolute;
    top: $bg-padding;
    left: $bg-padding;
    height: $button-height;
    width: $button-width;
    background-color: $color-1;
    border-radius: 50em;
    transition: transform $animation-time;
  }

  input[type='radio']:checked + label + .switch,
  input[type='radio']:checked + label:nth-of-type(n) + .switch {
    /* use label:nth-of-type(n) to fix a bug on safari with multiple adjacent-sibling selectors*/
    -webkit-transform: translateX($button-width);
    -moz-transform: translateX($button-width);
    -ms-transform: translateX($button-width);
    -o-transform: translateX($button-width);
    transform: translateX($button-width);
  }
}

form {
  padding-top: 0px;
  width: 100%;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btnUpload {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: normal;
  cursor: pointer !important;
}

input::placeholder {
  padding-left: 10px !important;
}

.btnUpload:hover {
  border: 2px solid var(--primaryDark);
  color: var(--primaryDark);
}
.btnUpload:active {
  background-color: var(--primaryDark);
}

.upload-btn-wrapper input[type='file'] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.edit-btn {
  background: var(--bg-light);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
}

.delete-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 230px;
  height: 40px;
  cursor: pointer;
}

/*** TOOL TIP CSS ***/
.tipWrapper {
  position: relative;
}

.help-tip {
  position: absolute;
  bottom: 10px;
  right: 50px;
  text-align: center;
  background-color: var(--grey-Dark);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 26px;
  cursor: default;
  z-index: 1;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover {
  cursor: pointer;
  background-color: var(--primaryDark) !important;
}

.help-tip:before {
  content: '?';
  font-weight: 700;
  color: #fff;
}

.help-tip p {
  visibility: hidden;
  opacity: 0;
  text-align: left;
  background-color: var(--grey-Dark);
  padding: 20px;
  width: 300px;
  position: absolute;
  border-radius: 4px;
  right: -4px;
  color: #fff;
  font-size: 13px;
  line-height: 1.2rem;
  transform: scale(0.7);
  transform-origin: 100% 0%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.help-tip:hover p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}
.help-tip:active p {
  cursor: default;
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}

.help-tip p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-bottom-color: var(--grey-Dark);
  right: 10px;
  top: -12px;
}

.help-tip p:after {
  width: 100%;
  height: 40px;
  content: '';
  position: absolute;
  top: -5px;
  left: 0;
}

.help-tip a {
  color: #fff;
  font-weight: 700;
}

.help-tip a:hover,
a:active .help-tip a:focus {
  color: #fff;
  text-decoration: underline;
}
// end of question tooltip//

@media screen and (max-width: 560px) {
  .container {
    width: 100%;
    padding: 10px;
    text-align: center !important;
    margin-left: 0 !important;
  }
  .help-tip {
    right: -5px;
  }
  .help-tip p {
    width: 1370%;
  }
  #video-tag {
    width: 100% !important;
  }
  .ytIcon {
    width: 30px;
  }
  .urlInput {
    width: 80%;
  }
}
</style>
